import { BlotterPanelContext } from 'contexts/blotters/BlotterPanelContext';
import { useContext } from 'react';

export const useBlotterPanelContext = () => useContext(BlotterPanelContext);
